import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getWorkOrderManagementRedirectPath = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.redirectPath;
  }
);
